// eslint-disable-next-line no-unused-vars
import React from 'react';
import styled from 'styled-components';

const StyledDiv = styled.div`
  margin-top: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledIframe = styled.iframe`
  @media (max-width: 1400px) {
    width: 261px !important;
  }

  @media (max-width: 1200px) {
    width: 216px !important;
  }

  @media (max-width: 992px) {
    width: 696px !important;
  }
`;

const DiscordWidget = () => {
  return (
    <StyledDiv>
      <StyledIframe
        src="https://discord.com/widget?id=925452666346303510&theme=dark"
        height="500"
        // eslint-disable-next-line react/no-unknown-property
        allowtransparency="true"
        frameBorder="0"
        sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"
        title="Discord Widget"
      ></StyledIframe>
    </StyledDiv>
  );
};

export default DiscordWidget;
